export const OtherContentSettings: any = {
  pdf: {
    download: true,
    fullScreen: true,
  },
};
